import { render, staticRenderFns } from "./AdvancedQuery.vue?vue&type=template&id=21bf089d&scoped=true"
import script from "./AdvancedQuery.vue?vue&type=script&lang=js"
export * from "./AdvancedQuery.vue?vue&type=script&lang=js"
import style0 from "./AdvancedQuery.vue?vue&type=style&index=0&id=21bf089d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf089d",
  null
  
)

export default component.exports